import type { AssessmentBlueprint } from "./types"

export const ASSESSMENT_BLUEPRINT_STORE_KEY = "shell:assessment-blueprints:v1"

export type AssessmentBlueprintStore = Record<string, AssessmentBlueprint>

export function readBlueprintStore(raw: string | null): AssessmentBlueprintStore {
  if (!raw) return {}
  try {
    const parsed = JSON.parse(raw) as AssessmentBlueprintStore
    return parsed && typeof parsed === "object" ? parsed : {}
  } catch {
    return {}
  }
}
